import { NgModule } from '@angular/core'
import { LOCATION } from '../variables'

export function locationFactory() {
  return window.location
}

@NgModule({
  providers: [{
    provide: LOCATION,
    useFactory: locationFactory
  }]
})
export class LocationModule {}
